module.exports = __webpack_public_path__ + "img/West-Mermis-Case-Study-300px.35513ad8.png";